import { useCallback } from "react";

import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";

import { INTENT_PROJECT_CONFIG_DELETE } from "./gql";

const deleteConfigHook = createDefaultMutationHook(INTENT_PROJECT_CONFIG_DELETE);

const useIntentProjectConfigDelete = () => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [deleteEnvVar, { loading, error }] = deleteConfigHook({
    refetchQueries: ["GetIntentProject", "GetIntentProjectConfig"],
  });

  const deleteConfigFromIntentProject = useCallback(
    (intentProjectId: string, configKey: string) => {
      deleteEnvVar({ project: intentProjectId, config: configKey }, (data) => {
        if (data?.intentProjectConfigDelete?.id) {
          reportSuccess({ message: "Config was successfully deleted." });
        }
      });
    },
    [deleteEnvVar, reportSuccess]
  );

  return {
    deleteConfigFromIntentProject,
    loading,
    error,
  };
};

export default useIntentProjectConfigDelete;
